import script from "./AudienceCompositionSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudienceCompositionSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./AudienceCompositionSkeleton.vue?vue&type=style&index=0&id=5dcd7370&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcd7370"]])

export default __exports__